import Link from 'next/link'

export const ContactUs = () => {
    return (
        <div itemScope itemType="https://schema.org/WebPage">
            <p
                className="text-lg font-bold text-center mt-11"
                itemProp="headline"
            >
                Looking for a Machine Learning solution custom built for your
                needs?
                <span>
                    <Link href="/contact">
                        <a className="ml-2">Contact us</a>
                    </Link>
                </span>
            </p>
        </div>
    )
}
